// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"457":"26724117","551":"170cae0f","851":"967f6c1b"}[chunkId] + ".chunk.js";
};